import {createElement} from 'react';
import DotPattern from './DotPattern.jsx';
import {PATTERN_PAINT_BOUNDS,patternTile,patternStampTile} from './pattern-tiles.js';

function renderNode(node,color,key='art'){
  const props=Object.fromEntries(Object.entries(node.props).map(([name,value])=>[name,value==='color'?color:value]));
  return createElement(node.tag,{...props,key},node.children?.map((child,index)=>renderNode(child,color,index)));
}
export default function PatternArtwork({layer,prefix}){
  if(layer.type==='dots')return <DotPattern layer={layer} prefix={prefix}/>;
  const id=`${prefix}pattern${layer.id}`,mask=`${id}cuts`,tile=patternTile(layer.type),cuts=layer.patternCuts||[];
  const holes=cuts.map(({x,y,r})=>`M${x-r} ${y}a${r} ${r} 0 1 0 ${r*2} 0a${r} ${r} 0 1 0 ${-r*2} 0Z`).join('');
  return <g data-pattern-type={layer.type} transform={layer.patternFlipX?'translate(100 0) scale(-1 1)':undefined}>
    <defs>
      <pattern id={id} width={tile.size} height={tile.size} patternUnits="userSpaceOnUse">{renderNode(tile.art,layer.color)}</pattern>
      {cuts.length>0&&<mask id={mask} maskUnits="userSpaceOnUse" maskContentUnits="userSpaceOnUse" {...PATTERN_PAINT_BOUNDS} style={{maskType:'luminance'}}>
        <rect {...PATTERN_PAINT_BOUNDS} fill="white"/>
        <path data-pattern-cuts={cuts.length} d={holes} fill="black" fillRule="nonzero"/>
      </mask>}
    </defs>
    {layer.stamp?<g mask={cuts.length?`url(#${mask})`:undefined}><g transform={`translate(${50-layer.strokeWidth/2} ${75-layer.strokeWidth/2}) scale(${layer.strokeWidth/patternStampTile(layer.type).size})`}>{renderNode(patternStampTile(layer.type).art,layer.color)}</g></g>:<rect {...PATTERN_PAINT_BOUNDS} fill={`url(#${id})`} mask={cuts.length?`url(#${mask})`:undefined}/>}
  </g>;
}
